/*
 * Kleurnummer-zoeker
 * ------------------
 * De klant typt een kleurnummer (bijv. 802) of meerdere tegelijk (111, 216, 480)
 * en legt die kleuren direct in het winkelmandje.
 *
 * De lijst met kleuren wordt opgebouwd uit:
 *   1. het product van deze pagina (staat al in de HTML, dus meteen bruikbaar)
 *   2. de andere producten uit dezelfde Swatch King-tintgroep
 *
 * Die worden opgehaald via /products/<handle>?section_id=kleurzoeker-data en
 * niet via /products/<handle>.js, want dat laatste geeft geen voorraadaantallen.
 *
 * Het kleurnummer komt uit het artikelnummer: 14.802 -> 802.
 * Raakt Swatch King niet geladen, dan werkt de zoeker gewoon voor deze pagina.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-kzk]');
  if (!root) return;

  var seedEl = root.querySelector('[data-kzk-seed]');
  var invoer = root.querySelector('.kzk__invoer');
  var wisKnop = root.querySelector('.kzk__wis');
  var resultaten = root.querySelector('.kzk__resultaten');
  var melding = root.querySelector('.kzk__melding');
  var land = root.getAttribute('data-land') || '';

  var CACHE_SLEUTEL = 'kzk-index-v4';
  var CACHE_MINUTEN = 10;
  var MAX_RESULTATEN = 8;

  var index = [];
  var opgehaald = {};
  var mand = [];
  var mandEl = null;
  var actieveRij = -1;
  var bezig = false;
  var magWarmen = false;
  var gewarmd = {};

  /* ---------- hulpjes ---------- */

  function nummerUit(sku, naam) {
    /* Eerst het nummer achter de kleurnaam ('Ivoor 111' -> 111). Dat is bij elke
       Gütermann-lijn het nummer dat op het klosje staat.
       Alleen als de naam geen nummer heeft, wordt het uit de SKU gehaald
       ('Zwart' -> 14.000 -> 000).

       Let op: bij 200m is de SKU toevallig 14.<kleurnummer>, maar bij de andere
       lijnen niet. Gutermann 30m 'Zwart 000' heeft SKU 15.129. Daarom is de naam
       leidend en de SKU alleen een vangnet. */
    var uitNaam = String(naam || '').match(/(\d+)\s*$/);
    if (uitNaam) return uitNaam[1];
    var bron = String(sku || '');
    var staart = bron.indexOf('.') > -1 ? bron.split('.').pop() : bron;
    return staart.replace(/\D/g, '');
  }

  function geld(cent) {
    return '€ ' + (cent / 100).toFixed(2).replace('.', ',');
  }

  function ontsnap(tekst) {
    return String(tekst).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function markeer(tekst, term) {
    var veilig = ontsnap(tekst);
    if (!term) return veilig;
    var i = veilig.toLowerCase().indexOf(term.toLowerCase());
    if (i < 0) return veilig;
    return veilig.slice(0, i) + '<span class="kzk__mark">' +
      veilig.slice(i, i + term.length) + '</span>' + veilig.slice(i + term.length);
  }

  function zeg(tekst, soort) {
    melding.textContent = tekst || '';
    melding.className = 'kzk__melding' + (soort ? ' kzk__melding--' + soort : '');
  }

  /* Zelfde regels als de voorraadmelding op de productpagina:
     op voorraad -> groen; wel verkoopbaar maar niets liggen -> levertijd;
     Duitsland staat achteraf leveren niet toe. */
  function voorraadInfo(r, gevraagd) {
    /* Net als de productpagina wordt er vergeleken met het gekozen aantal, niet
       met 1. Vraagt iemand 33 klosjes terwijl er 5 liggen, dan is dat een
       nabestelling en hoort daar 'Levertijd 2-3 werkdagen' te staan. */
    var stuks = gevraagd || 1;
    var genoeg = !r.tracked || r.aantal >= stuks;
    if (!r.voorraad) return { tekst: 'Niet op voorraad', op: true, kan: false };
    if (land === 'DE' && !genoeg) return { tekst: 'Niet op voorraad', op: true, kan: false };
    if (genoeg) return { tekst: 'Op voorraad', op: false, kan: true };
    return { tekst: 'Levertijd 2-3 werkdagen', op: false, kan: true };
  }

  /* ---------- index opbouwen ---------- */

  function voegToe(handle, varianten) {
    if (opgehaald[handle]) return;
    varianten.forEach(function (v) {
      var nummer = nummerUit(v.sku, v.naam);
      index.push({
        id: v.id,
        handle: handle,
        nummer: nummer,
        nummerInt: nummer ? parseInt(nummer, 10) : null,
        naam: v.naam || '',
        naamLaag: (v.naam || '').toLowerCase(),
        voorraad: v.voorraad,
        tracked: v.tracked,
        aantal: v.aantal,
        prijs: v.prijs,
        afbeelding: v.afbeelding || null
      });
    });
    opgehaald[handle] = true;
  }

  function leesSeed() {
    try {
      var seed = JSON.parse(seedEl.textContent);
      voegToe(seed.handle, seed.varianten || []);
      return true;
    } catch (e) {
      return false;
    }
  }

  function groepsHandles() {
    var handles = [];
    document.querySelectorAll('.swatch-group-selector[swatch-url]').forEach(function (el) {
      var m = String(el.getAttribute('swatch-url')).match(/\/products\/([^/?#]+)/);
      if (m && handles.indexOf(m[1]) < 0) handles.push(m[1]);
    });
    return handles;
  }

  function uitCache(handles) {
    try {
      var pot = JSON.parse(sessionStorage.getItem(CACHE_SLEUTEL) || 'null');
      if (!pot) return null;
      if (pot.sleutel !== handles.slice().sort().join(',')) return null;
      if (Date.now() - pot.tijd > CACHE_MINUTEN * 60000) return null;
      return pot.items;
    } catch (e) {
      return null;
    }
  }

  function naarCache(handles) {
    try {
      sessionStorage.setItem(CACHE_SLEUTEL, JSON.stringify({
        sleutel: handles.slice().sort().join(','),
        tijd: Date.now(),
        items: index
      }));
    } catch (e) { /* vol of geblokkeerd: dan halen we het later opnieuw op */ }
  }

  /* Haalt één product op inclusief voorraad. De sectie levert een JSON-blokje. */
  function haalProduct(handle) {
    return fetch('/products/' + handle + '?section_id=kleurzoeker-data', {
      headers: { Accept: 'text/html' }
    }).then(function (r) {
      return r.ok ? r.text() : null;
    }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('[data-kzk-data]');
      if (!el) return;
      var data = JSON.parse(el.textContent);
      voegToe(data.handle, data.varianten || []);
    }).catch(function () { /* dit product overslaan */ });
  }

  function haalGroepOp() {
    var handles = groepsHandles();
    if (!handles.length) return;

    var bewaard = uitCache(handles);
    if (bewaard && bewaard.length) {
      index = bewaard;
      index.forEach(function (r) { opgehaald[r.handle] = true; });
      warmOp();
      herteken();
      return;
    }

    Promise.all(handles.filter(function (h) { return !opgehaald[h]; }).map(haalProduct))
      .then(function () {
        naarCache(handles);
        warmOp();
        herteken();
      });
  }

  /* Swatch King tekent de tintknoppen pas na het laden; even geduld hebben. */
  function wachtOpGroep() {
    var pogingen = 0;
    var tik = setInterval(function () {
      pogingen++;
      if (groepsHandles().length) {
        clearInterval(tik);
        haalGroepOp();
      } else if (pogingen > 30) {
        clearInterval(tik); // 6 seconden: het blijft bij dit ene product
      }
    }, 200);
  }

  /* De klosfoto's alvast ophalen zodra de klant het vakje aanklikt, in kleine
     porties tussen ander werk door. Dan staan ze klaar zodra hij typt. */
  function warmLijst(urls) {
    var lijst = urls.filter(function (u) { return u && !gewarmd[u]; });
    if (!lijst.length) return;
    var i = 0;
    (function portie() {
      var eind = Math.min(i + 24, lijst.length);
      for (; i < eind; i++) {
        gewarmd[lijst[i]] = true;
        var im = new Image();
        im.decoding = 'async';
        im.src = lijst[i];
      }
      if (i < lijst.length) setTimeout(portie, 120);
    })();
  }

  /* Voorschot zodra de klant het vakje aanklikt: de eerste zestig klosjes. */
  function warmOp() {
    if (!magWarmen) return;
    warmLijst(index.slice(0, 60).map(function (r) { return r.afbeelding; }));
  }

  /* Tijdens het typen vooruitlopen. Iemand die 276 intikt, typt eerst 2 en 27;
     die tussenstappen halen 276 al binnen, dus zodra hij klaar is staat de foto
     er al. We nemen er meer dan we tonen, want het laatste cijfer verkleint de
     lijst maar haalt er niets bij. */
  function warmTreffers(treffers) {
    warmLijst(treffers.slice(0, 30).map(function (r) { return r.afbeelding; }));
  }

  /* ---------- zoeken ---------- */

  function zoek(term) {
    var schoon = term.trim();
    if (!schoon) return [];
    var laag = schoon.toLowerCase();
    var cijfers = schoon.replace(/\D/g, '');
    var alsGetal = cijfers ? parseInt(cijfers, 10) : null;

    var treffers = [];
    index.forEach(function (r) {
      var score = -1;
      if (alsGetal !== null && r.nummerInt === alsGetal) score = 0;
      else if (cijfers && r.nummer.indexOf(cijfers) === 0) score = 1;
      else if (cijfers && r.nummer.indexOf(cijfers) > -1) score = 2;
      else if (r.naamLaag.indexOf(laag) > -1) score = 3;
      if (score > -1) treffers.push({ rij: r, score: score });
    });

    treffers.sort(function (a, b) {
      if (a.score !== b.score) return a.score - b.score;
      var av = voorraadInfo(a.rij).kan, bv = voorraadInfo(b.rij).kan;
      if (av !== bv) return av ? -1 : 1;
      return (a.rij.nummerInt || 0) - (b.rij.nummerInt || 0);
    });
    return treffers.map(function (t) { return t.rij; });
  }

  function isBulk(tekst) {
    if (/[,;\n\t]/.test(tekst)) return true;
    return tekst.trim().split(/\s+/).filter(function (s) { return /\d/.test(s); }).length > 1;
  }

  function splits(tekst) {
    return tekst.split(/[,;\n\t\s]+/).map(function (s) { return s.trim(); })
      .filter(function (s) { return s; });
  }

  /* ---------- tekenen ---------- */

  function fotoHtml(r) {
    if (!r.afbeelding) return '<span class="kzk__foto"></span>';
    return '<img class="kzk__foto" src="' + ontsnap(r.afbeelding) +
      '" alt="" decoding="async" fetchpriority="high">';
  }

  function voorraadHtml(v) {
    return '<span class="kzk__voorraad' + (v.op ? ' kzk__voorraad--op' : '') + '">' +
      '<span class="kzk__bol"></span>' + v.tekst + '</span>';
  }

  function toonResultaten(term) {
    var alles = zoek(term);
    warmTreffers(alles);
    var lijst = alles.slice(0, MAX_RESULTATEN);
    actieveRij = -1;

    if (!lijst.length) {
      resultaten.innerHTML = '';
      resultaten.hidden = true;
      invoer.setAttribute('aria-expanded', 'false');
      zeg('Kleurnummer ' + term.trim() + ' kennen we niet. Controleer het nummer op het klosje.', 'fout');
      return;
    }

    resultaten.innerHTML = lijst.map(function (r) {
      var v = voorraadInfo(r);
      return '<div class="kzk__rij' + (v.kan ? '' : ' kzk__rij--op') + '" role="option" data-id="' + r.id + '">' +
        fotoHtml(r) +
        '<span class="kzk__tekst"><span class="kzk__naam">' + markeer(r.naam, term) + '</span>' +
        voorraadHtml(v) + '</span>' +
        '<button type="button" class="kzk__voegtoe" data-voeg="' + r.id + '"' +
        ' data-kan="' + (v.kan ? 'ja' : 'nee') + '"' +
        (v.kan ? '' : ' disabled') + '>In winkelmandje</button>' +
        '</div>';
    }).join('');
    resultaten.hidden = false;
    invoer.setAttribute('aria-expanded', 'true');
    zeg('');
  }

  function tekenMand() {
    if (!mandEl) {
      mandEl = document.createElement('div');
      mandEl.className = 'kzk__mand';
      resultaten.parentNode.insertBefore(mandEl, melding);
    }
    if (!mand.length) { mandEl.hidden = true; return; }

    var totaal = mand.reduce(function (a, m) { return a + m.rij.prijs * m.aantal; }, 0);
    var stuks = mand.reduce(function (a, m) { return a + m.aantal; }, 0);

    var geblokkeerd = mand.some(function (m) { return !voorraadInfo(m.rij, m.aantal).kan; });

    mandEl.innerHTML = mand.map(function (m, i) {
      return '<div class="kzk__mandrij">' + fotoHtml(m.rij) +
        '<span class="kzk__tekst"><span class="kzk__naam">' + ontsnap(m.rij.naam) + '</span>' +
        voorraadHtml(voorraadInfo(m.rij, m.aantal)) + '</span>' +
        '<span class="kzk__aantal">' +
        '<button type="button" data-min="' + i + '" aria-label="Eén minder">−</button>' +
        '<span>' + m.aantal + '</span>' +
        '<button type="button" data-plus="' + i + '" aria-label="Eén meer">+</button>' +
        '</span></div>';
    }).join('') +
      '<button type="button" class="kzk__knop" data-alles data-kan="' +
      (geblokkeerd ? 'nee' : 'ja') + '"' + (geblokkeerd ? ' disabled' : '') + '>' +
      stuks + ' ' + (stuks === 1 ? 'klosje' : 'klosjes') + ' in winkelmandje · ' + geld(totaal) +
      '</button>';
    mandEl.hidden = false;
  }

  function toonBulk(tekst) {
    resultaten.hidden = true;
    resultaten.innerHTML = '';
    invoer.setAttribute('aria-expanded', 'false');

    var onbekend = [];
    var nietLeverbaar = [];
    mand = [];

    splits(tekst).forEach(function (stuk) {
      var treffer = zoek(stuk)[0];
      if (!treffer) { onbekend.push(stuk); return; }
      if (!voorraadInfo(treffer).kan) { nietLeverbaar.push(treffer.nummer || treffer.naam); return; }
      var bestaat = mand.filter(function (m) { return m.rij.id === treffer.id; })[0];
      if (bestaat) bestaat.aantal++;
      else mand.push({ rij: treffer, aantal: 1 });
    });

    tekenMand();

    var opmerkingen = [];
    if (onbekend.length) opmerkingen.push('Niet gevonden: ' + onbekend.join(', '));
    if (nietLeverbaar.length) opmerkingen.push('Niet op voorraad: ' + nietLeverbaar.join(', '));
    if (opmerkingen.length) zeg(opmerkingen.join(' · '), 'fout');
    else if (mand.length) zeg('');
    else zeg('Geen van deze nummers gevonden. Controleer ze op het klosje.', 'fout');
  }

  function herteken() {
    var tekst = invoer.value;
    if (!tekst.trim()) return;
    if (isBulk(tekst)) toonBulk(tekst); else toonResultaten(tekst);
  }

  /* ---------- in het mandje leggen ---------- */

  function meldMandjeBij(data) {
    /* De Smart Cart-app onderschept /cart/add.js zelf en werkt het mandje al bij.
       Alleen als die app er niet is, geven we het thema zelf een seintje. */
    if (window.Rebuy && window.Rebuy.SmartCart) return;
    ['cart:refresh', 'cart:build', 'cart:updated'].forEach(function (naam) {
      document.dispatchEvent(new CustomEvent(naam, { bubbles: true, detail: data }));
    });
  }

  function zetVast(aan) {
    root.querySelectorAll('.kzk__voegtoe, .kzk__knop').forEach(function (b) {
      if (aan) b.disabled = true;
      else b.disabled = (b.getAttribute('data-kan') === 'nee');
    });
  }

  function inMandje(items, omschrijving) {
    if (bezig || !items.length) return;
    bezig = true;
    zetVast(true);
    zeg('Bezig met toevoegen…');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Toevoegen is niet gelukt.');
        return data;
      });
    }).then(function (data) {
      meldMandjeBij(data);
      zeg(omschrijving + ' in uw winkelmandje gelegd.', 'ok');
      invoer.value = '';
      wisKnop.hidden = true;
      resultaten.hidden = true;
      resultaten.innerHTML = '';
      invoer.setAttribute('aria-expanded', 'false');
      mand = [];
      tekenMand();
      invoer.focus();
    }).catch(function (e) {
      zeg(e.message || 'Toevoegen is niet gelukt. Probeer het nog een keer.', 'fout');
    }).then(function () {
      bezig = false;
      zetVast(false);
    });
  }

  function voegEenToe(id) {
    var rij = index.filter(function (r) { return r.id === id; })[0];
    if (!rij || !voorraadInfo(rij).kan) return;
    inMandje([{ id: id, quantity: 1 }], rij.naam);
  }

  function voegAllesToe() {
    inMandje(
      mand.map(function (m) { return { id: m.rij.id, quantity: m.aantal }; }),
      mand.length === 1 ? mand[0].rij.naam : mand.length + ' kleuren'
    );
  }

  /* ---------- bediening ---------- */

  invoer.addEventListener('focus', function () {
    /* Pas foto's vooraf ophalen als de klant het vakje aanklikt: dat is het
       moment dat hij ze zo nodig heeft, en het scheelt data bij wie het niet
       gebruikt. Nagekomen producten worden later alsnog meegenomen. */
    magWarmen = true;
    warmOp();
  });

  invoer.addEventListener('input', function () {
    wisKnop.hidden = !invoer.value;
    if (!invoer.value.trim()) {
      resultaten.hidden = true;
      resultaten.innerHTML = '';
      invoer.setAttribute('aria-expanded', 'false');
      mand = [];
      tekenMand();
      zeg('');
      return;
    }
    herteken();
  });

  wisKnop.addEventListener('click', function () {
    invoer.value = '';
    wisKnop.hidden = true;
    resultaten.hidden = true;
    resultaten.innerHTML = '';
    invoer.setAttribute('aria-expanded', 'false');
    mand = [];
    tekenMand();
    zeg('');
    invoer.focus();
  });

  invoer.addEventListener('keydown', function (e) {
    var rijen = resultaten.hidden ? [] :
      Array.prototype.slice.call(resultaten.querySelectorAll('.kzk__rij:not(.kzk__rij--op)'));

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!rijen.length) return;
      e.preventDefault();
      actieveRij += (e.key === 'ArrowDown' ? 1 : -1);
      if (actieveRij < 0) actieveRij = rijen.length - 1;
      if (actieveRij >= rijen.length) actieveRij = 0;
      rijen.forEach(function (r, i) { r.classList.toggle('kzk__rij--actief', i === actieveRij); });
      rijen[actieveRij].scrollIntoView({ block: 'nearest' });
      return;
    }

    if (e.key === 'Enter') {
      e.preventDefault();
      if (mand.length) voegAllesToe();
      else if (rijen.length) {
        var doel = rijen[actieveRij > -1 ? actieveRij : 0];
        voegEenToe(parseInt(doel.getAttribute('data-id'), 10));
      }
      return;
    }

    if (e.key === 'Escape') {
      resultaten.hidden = true;
      invoer.setAttribute('aria-expanded', 'false');
    }
  });

  root.addEventListener('click', function (e) {
    var voeg = e.target.closest('[data-voeg]');
    var plus = e.target.closest('[data-plus]');
    var min = e.target.closest('[data-min]');
    var alles = e.target.closest('[data-alles]');
    if (voeg && !voeg.disabled) voegEenToe(parseInt(voeg.getAttribute('data-voeg'), 10));
    if (plus) { mand[+plus.getAttribute('data-plus')].aantal++; tekenMand(); }
    if (min) {
      var i = +min.getAttribute('data-min');
      mand[i].aantal--;
      if (mand[i].aantal < 1) mand.splice(i, 1);
      tekenMand();
    }
    if (alles) voegAllesToe();
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) {
      resultaten.hidden = true;
      invoer.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- starten ---------- */

  if (leesSeed()) {
    root.hidden = false;
    wachtOpGroep();
  }
})();
